export default __webpack_public_path__ + "static/img-pelith-5ff67a0a0c50778b40eff5e51c60a927.png";